export default __webpack_public_path__ + "static/portfolio-img-3-352398db2dfe764462ac327070ec4e32.png";